import React from 'react';
import {FormattedMessage} from "react-intl";
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

export function StatusColumnFormatter(cellContent) {
  const prefix = 'paypal-requests-status';
  const getStatus = (actionType) => {
    const containerClassnames = 'font-weight-bolder font-size-lg text-nowrap';
    switch (actionType) {
      case 'pending': return (
        <div className={containerClassnames} style={{color: '#F9C70C'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Repeat_yellow.svg')}
            alt="pending"
            className={'mr-2'}
          />
          <FormattedMessage id={`${prefix}-pending`} defaultMessage="Pending"/>
        </div>
      )
      case 'success': return (
        <div className={containerClassnames} style={{color: '#28a745'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Check.svg')}
            alt="success"
            className={'mr-2'}
          />
          <FormattedMessage id={`${prefix}-success`} defaultMessage="Success"/>
        </div>
      )
      case 'cancel': return (
        <div className={containerClassnames} style={{color: '#dc3545'}}>
          <img
            src={toAbsoluteUrl('/media/svg/Cross.svg')}
            alt="fail"
            className={'mr-2'}
          />
          <FormattedMessage id={`${prefix}-cancel`} defaultMessage="Cancel"/>

        </div>
      )
      default: return null
    }
  };

  return getStatus(cellContent);
}
